/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_PageInputs */

const en_refresh_page = /** @type {(inputs: Refresh_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh page`)
};

const nl_refresh_page = /** @type {(inputs: Refresh_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina vernieuwen`)
};

/**
* | output |
* | --- |
* | "Refresh page" |
*
* @param {Refresh_PageInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const refresh_page = /** @type {((inputs?: Refresh_PageInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_PageInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_refresh_page(inputs)
	return en_refresh_page(inputs)
});